import React from 'react'
import ContainerUnauthenticated from 'containers/Unauthenticated'
import Button from 'components/Form/Button'
import { Icon } from 'ui/styled'
import useController from './controller'
import { Screen, Eyebrow, Heading, Subtitle, Areas, AreaButton, Artwork, AreaName, Description, Enter, Footer, Message, Skeleton } from './styled'

export default function ChooseArea() {
  const { t, areas, loading, selecting, error, select, retry, logout } = useController()
  return (
    <ContainerUnauthenticated success>
      <Screen aria-labelledby="area-heading" aria-busy={loading || Boolean(selecting)}>
        <Eyebrow>{t('area_eyebrow')}</Eyebrow>
        <Heading id="area-heading">{t('area_heading')}</Heading>
        <Subtitle>{t('area_subtitle')}</Subtitle>
        {loading ? (
          <Areas role="status" aria-label={t('area_loading')}>
            {[0, 1, 2].map(index => <Skeleton key={index} />)}
          </Areas>
        ) : (
          <Areas aria-label={t('area_heading')}>
            {areas.map(area => (
              <AreaButton key={area} type="button" onClick={() => select(area)} disabled={Boolean(selecting)} aria-label={`${t('area_enter')} ${t(`area_${area}_name`)}`}>
                <Artwork><Icon icon={`area-${area}`} alt="" width={100} height={100} /></Artwork>
                <AreaName>{t(`area_${area}_name`)}</AreaName>
                <Description>{t(`area_${area}_description`)}</Description>
                <Enter>{selecting === area ? t('area_opening') : t('area_enter')} <span aria-hidden="true">↗</span></Enter>
              </AreaButton>
            ))}
          </Areas>
        )}
        {error ? <Message role="alert"><p>{t('area_error')}</p><Button color="blue" onClick={retry} disabled={Boolean(selecting)}>{t('area_retry')}</Button></Message> : null}
        {!loading && !error && areas.length === 0 ? <Message role="status">{t('area_empty')}</Message> : null}
        <Footer>
          <span>{t('area_footer')}</span>
          <Button link small color="white" onClick={logout} disabled={Boolean(selecting)}>{t('area_sign_out')}</Button>
        </Footer>
      </Screen>
    </ContainerUnauthenticated>
  )
}
